import { CalcsResultsTypes } from './calcs-results-types';

export class CalcsResults {
    
    main: CalcsResultsTypes
    alternatives: CalcsResultsTypes
    all: CalcsResultsTypes
    porAssinatura: CalcsResultsTypes

    constructor(){
        this.main = new CalcsResultsTypes();
        this.alternatives = new CalcsResultsTypes();
        this.all = new CalcsResultsTypes();
        this.porAssinatura = new CalcsResultsTypes();
    }

}